import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export const TripInformationSchema = ({ customizationFields, resourceType }: FormContext) => {
  return z.object({
    from: z
      .string()
      .nullish()
      .refine(
        (from) => (isMandatory('from', resourceType, customizationFields) ? !!from : true),
        defaultRequiredMessage()
      ),
    to: z
      .string()
      .nullish()
      .refine(
        (to) => (isMandatory('to', resourceType, customizationFields) ? !!to : true),
        defaultRequiredMessage()
      ),
    originLatitude: z.string().nullish(),
    originLongitude: z.string().nullish(),
    destinationLatitude: z.string().nullish(),
    destinationLongitude: z.string().nullish(),
    stops: z
      .array(
        z.object({
          name: z.string().nullish(),
          latitude: z.string().nullish(),
          longitude: z.string().nullish(),
        })
      )
      .optional()
      .default([]),
  })
}

export type TripInformationSchema = z.infer<ReturnType<typeof TripInformationSchema>>
